import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalOptionValue } from '../core/local-option-value';
import { ServiceBaseService } from '../core/service-base.service';
import { GenericDataService } from '../shared/generic-data.service';

@Injectable({
  providedIn: 'root',
})
export class SettingsOptionsService extends GenericDataService<LocalOptionValue> {
  endpointName = '/localoptionvalue';
  constructor(http: HttpClient, serviceBase: ServiceBaseService) {
    super(http, serviceBase);
  }
}
